export default __webpack_public_path__ + "static/media/lalamove_4x4.e25f82c5.png";